import React from 'react';
import { Button } from '../../components/ui/button';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '../../components/ui/accordion';
import { Save } from 'lucide-react';
import { defaultDonateContent } from '../../siteContent';
import { useCms, Text, ImageField } from './cmsShared';

const AdminContentDonate = () => {
  const { content: c, update, uploadImage, save, saving } = useCms('donate', defaultDonateContent);
  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div><h2 className="font-heading text-xl font-bold text-[#003366]">Donate Page — Content</h2>
        <p className="text-sm text-gray-500">Edit hero, image, bank details and corporate section. (Razorpay to be added later.)</p></div>
        <Button onClick={save} disabled={saving} data-testid="cms-donate-save-btn" className="rounded-full bg-[#E74C3C] hover:bg-[#C0392B]"><Save className="w-4 h-4 mr-2" />{saving ? 'Saving…' : 'Save Changes'}</Button>
      </div>
      <Accordion type="multiple" defaultValue={['hero', 'bank']} className="space-y-2">
        <AccordionItem value="hero" className="border rounded-xl px-4 bg-white">
          <AccordionTrigger data-testid="cms-donate-section-hero">Hero & Intro</AccordionTrigger>
          <AccordionContent>
            <Text label="Hero title" value={c.hero.title} onChange={(v) => update(['hero', 'title'], v)} testid="cms-donate-hero-title" />
            <Text label="Hero subtext" value={c.hero.subtext} onChange={(v) => update(['hero', 'subtext'], v)} area />
            <ImageField label="Hero image" value={c.image} onChange={(v) => update(['image'], v)} onUpload={(f) => uploadImage(['image'], f)} testid="cms-donate-image" />
            <Text label="Intro paragraph" value={c.intro} onChange={(v) => update(['intro'], v)} area />
            <Text label="Tax note (80G)" value={c.taxNote} onChange={(v) => update(['taxNote'], v)} area />
          </AccordionContent>
        </AccordionItem>
        <AccordionItem value="bank" className="border rounded-xl px-4 bg-white">
          <AccordionTrigger data-testid="cms-donate-section-bank">Bank Transfer Details</AccordionTrigger>
          <AccordionContent>
            <Text label="Section heading" value={c.bank.heading} onChange={(v) => update(['bank', 'heading'], v)} />
            <Text label="Account name" value={c.bank.accountName} onChange={(v) => update(['bank', 'accountName'], v)} testid="cms-donate-acct-name" />
            <Text label="Account number" value={c.bank.accountNumber} onChange={(v) => update(['bank', 'accountNumber'], v)} />
            <Text label="Bank name" value={c.bank.bankName} onChange={(v) => update(['bank', 'bankName'], v)} />
            <Text label="IFSC" value={c.bank.ifsc} onChange={(v) => update(['bank', 'ifsc'], v)} />
            <Text label="Branch" value={c.bank.branch} onChange={(v) => update(['bank', 'branch'], v)} />
            <Text label="UPI ID" value={c.bank.upi} onChange={(v) => update(['bank', 'upi'], v)} />
          </AccordionContent>
        </AccordionItem>
        <AccordionItem value="corp" className="border rounded-xl px-4 bg-white">
          <AccordionTrigger>Corporate / CSR</AccordionTrigger>
          <AccordionContent>
            <Text label="Heading" value={c.corporateHeading} onChange={(v) => update(['corporateHeading'], v)} />
            <Text label="Text" value={c.corporateText} onChange={(v) => update(['corporateText'], v)} area />
            <Text label="Contact email" value={c.contactEmail} onChange={(v) => update(['contactEmail'], v)} />
          </AccordionContent>
        </AccordionItem>
      </Accordion>
      <div className="flex justify-end mt-6"><Button onClick={save} disabled={saving} className="rounded-full bg-[#E74C3C] hover:bg-[#C0392B]"><Save className="w-4 h-4 mr-2" />{saving ? 'Saving…' : 'Save Changes'}</Button></div>
    </div>
  );
};

export default AdminContentDonate;
